
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/articulo.vue';
    import movil from './pc/articulo.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {
        created()
        {
            if ( !this.$route.params.id )
            {
                this.$router.replace( '/productos' );
            }
        }


    }
